import React, { useEffect, useState } from 'react'
import { Badge, Button, Card, ListGroup } from 'react-bootstrap'
import EventTicketModal from './ticket-modal'
import { FaCross, FaTimes, FaTrash } from 'react-icons/fa'

export default function EventsTicketContainer({eventTickets, setEventsTickets}) {
  const [createEventModal, setCreateEventModal] = useState(false)
  const [selectedTicketId, setSelectedTicketId] = useState(null)

  // To do: Import this from a Utilities function file
  function formatCurrency(number, currencySymbol = '$', decimalPlaces = 2) {
    number = parseFloat(number)
    let formattedNumber = number.toFixed(decimalPlaces);
    if (decimalPlaces === 0) {
      formattedNumber = formattedNumber.split('.')[0];
    }
    if (number < 0) {
      return `-${currencySymbol}${formattedNumber.replace('-', '')}`;
    }
    return `${currencySymbol}${formattedNumber}`;
  }

  function deleteTicket(key) {
    const prevEventsTickets = [...eventTickets]
    prevEventsTickets.splice(key, 1)
    setEventsTickets(prevEventsTickets)
  }

  useEffect(()=>{
    if (createEventModal === false) {
      setSelectedTicketId(false)
    }
  }, [createEventModal])
  
  return (
    <div>
      <Button
        variant='secondary'
        size='lg'
        onClick={() => {
          setCreateEventModal(true)
        }}>
        Create Ticket
      </Button>
      <EventTicketModal
        title={(selectedTicketId !== false?'Edit':'Create')+ ' Ticket'}
        createEventModal={createEventModal}
        setCreateEventModal={setCreateEventModal}
        eventTickets={eventTickets}
        setEventsTickets={setEventsTickets}
        selectedTicketId={selectedTicketId}
      />
      {eventTickets.length ? (
        <ListGroup className="my-5">
          {eventTickets.map((event_ticket, key) => (
            <ListGroup.Item
              key={key}
              className="d-flex justify-content-between align-items-center"
            >
              {/* Start of ticket item */}
              <div className="d-flex align-items-center gap-3 w-100">
                <Button variant="outline-danger" onClick={()=>{
                  deleteTicket(key)
                }}>
                  <FaTimes />
                </Button>
                <div className="d-flex justify-content-between align-items-start w-100" 
                  onClick={() => {
                  setSelectedTicketId(key);
                  setCreateEventModal(true);
                }}>
                  <div>
                    <h5 className="mb-1 text-start">{event_ticket.name}</h5>
                    <h6 className="text-start mb-0">{formatCurrency(event_ticket.price)}</h6>
                  </div>
                  <Badge bg="primary" pill>
                    {event_ticket.quantity}
                  </Badge>
                </div>
              </div>
              {/* End of ticket item */}
            </ListGroup.Item>
          ))}
        </ListGroup>
      ) : (
        <Card className='my-5'>
          <Card.Body className='text-center'>You have created 0 tickets for this event.</Card.Body>
        </Card>
      )}
    </div>
  )
}
